import gql from 'graphql-tag';

export const projectsRemediationRateDetails = gql`
  fragment SecurityRemediationRateFragment on ProjectsRemediationRate {
    totalFixableIssues
    totalOpenIssues
    totalIssues
    totalFixedIssues
  }
  query {
    projectsRemediationRateDetails {
      base {
        ...SecurityRemediationRateFragment
      }
      upstream {
        ...SecurityRemediationRateFragment
      }
    }
  }
`;
